import { computed, unref } from 'vue'

export function normalizeSupportPhoneTel(supportPhone) {
  return String(unref(supportPhone) ?? '').replace(/[^\d+]/g, '')
}

export function openAuthHelp(supportPhone) {
  const tel = normalizeSupportPhoneTel(supportPhone)

  if (typeof window.Tawk_API?.maximize === 'function') {
    window.Tawk_API.maximize()
    return
  }

  if (tel) {
    window.location.href = `tel:${tel}`
  }
}

export function useAuthHelp(supportPhone) {
  const supportPhoneTel = computed(() => normalizeSupportPhoneTel(supportPhone))

  const openHelp = (event) => {
    event?.preventDefault()
    openAuthHelp(supportPhone)
  }

  return {
    supportPhoneTel,
    openHelp,
  }
}
